
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.667 11.25h6.666M6.667 7.083H10","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.082 15.833c-1.083-.106-1.895-.432-2.439-.976-.976-.976-.976-2.548-.976-5.69V8.75c0-3.143 0-4.714.976-5.69.976-.977 2.548-.977 5.69-.977h3.334c3.142 0 4.714 0 5.69.977.976.976.976 2.547.976 5.69v.417c0 3.142 0 4.714-.976 5.69s-2.548.976-5.69.976c-.467.01-.84.046-1.205.13-.999.23-1.923.74-2.837 1.186-1.302.635-1.953.953-2.362.655-.782-.582-.018-2.386.154-3.22","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    